export default "__VITE_ASSET__4e963134__"